import type { LayoutLoad } from './$types';
import { error } from '@sveltejs/kit';
import { getCMSComponents } from '@app/components/cms';
import { t } from 'svelte-i18n';
import { get } from 'svelte/store';

export const load: LayoutLoad = async ({ url, fetch }) => {
	const $t = get(t);
	const res = await fetch(`/cms${url.pathname === '/' ? '/home-page' : url.pathname}`);

	if (res.ok) {
		const json = await res.json();
		const compArray = await getCMSComponents(json.content.body);

		return {
			story: json,
			FullCMSComponents: compArray
		};
	} else {
		error(res.status, $t('noDataFromCMS'));
	}
};
